import React from 'react';

import { Language } from '../domain/types';

interface Props {
  currentLang: Language;
  setCurrentLang: (lang: Language) => void;
  hasGerman: boolean;
  hasFrench: boolean;
}

const LanguageSelector: React.FC<Props> = ({ currentLang, setCurrentLang, hasGerman, hasFrench }) => {

  const [hoveredLang, setHoveredLang] = React.useState<Language | null>(null);

  return (
    <span style={{display: 'flex', marginBottom: 0, justifyContent: 'flex-end', flexShrink: 0}}>
      {Object.values(Language).map((value) => {

        if (value === 'de' && !hasGerman) {
          return null;
        }

        if (value === 'fr' && !hasFrench) {
          return null;
        }

        const isActive = currentLang === value;
        const isHovered = hoveredLang === value;

        return (
          <h4 
            key={value}
            onClick={() => setCurrentLang(value)}
            style={{
              marginRight: 16,
              fontSize: '1.5rem',
              cursor: 'pointer',
              marginTop: 4,
              marginBottom: 4,
            }}
            onMouseEnter={() => setHoveredLang(value)}
            onMouseLeave={() => setHoveredLang(null)}
          >
            <span
              style={{
                color: !isActive && isHovered ? '#DB2600'  : 'white',
                opacity: isActive ? 1 : 0.5,
              }}
            >
              {value.toUpperCase()}
            </span>
          </h4>
        );
      })}
    </span>
  );
};

export default LanguageSelector;